import { getRouteObjectList, withLayout } from '../feature/router/util/router.helper'
import { RouterLayout } from '../feature/router/component/layout/RouterLayout'
import { OnboardingStoreProvider } from '../feature/on-boarding/store/onboarding.store'

function SignUpProvider() {
  return (
    <OnboardingStoreProvider>
      <RouterLayout />
    </OnboardingStoreProvider>
  )
}

export const SignUpRoutes = withLayout({
  layout: <SignUpProvider />,
  routes: getRouteObjectList(['signUp', 'companySignUp']),
})
